import Icon from '../icon';
import CentredComponentContainer from './centredComponentContainer';

export default function Spinner() {
  return (
    <CentredComponentContainer>
      <Icon.Spinner height={48} width={39.75} />
    </CentredComponentContainer>
  );
}
